import React from 'react';


const App = ({ children }) => {
    
    return (
        <div>
            {children}
        </div>
    );
};

export default App;


// WEBPACK FOOTER //
// ./src/app/components/app.js